import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { assetUrl } from 'src/app/globals/globals';
import { Benefit } from 'src/app/interfaces/benefit/benefit.interface';
import { BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { CategoryService } from 'src/app/services/api/categories/category.service';
import { LocationService } from 'src/app/services/api/location/location.service';
import { SliderService } from 'src/app/services/api/sliders/slider.service';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-festivities-opportunities',
  templateUrl: './festivities-opportunities.component.html',
  styleUrls: ['./festivities-opportunities.component.scss'],
})
export class FestivitiesOpportunitiesComponent implements OnInit {
  assetUrl = assetUrl;
  benefits: Benefit[] = [];
  displayedBenefits: Benefit[] = [];
  loadingBenefits = true;
  waitText = 'No encontramos ningún beneficio';
  config: SwiperOptions = {
    autoplay: true,
    initialSlide: 0,
    slidesPerView: 1.1,
    pagination: {
      clickable: true,
    },
    rewind: true,
    centeredSlides: true,
    breakpoints: {
      1100: {
        slidesPerView: 1.05,
      },
      1280: {
        slidesPerView: 1.3,
      },
    },
  };
  sliders: any = [];
  items = [{ imgUrl: '../../../assets/images/banner/festividadesBannerDesktop.png' }];
  itemsMobile = [{ imgUrlMobile: '../../../assets/images/banner/festividadesBannerMobile.png' }];
  categoriesTag: FormGroup;
  categories: any = [];
  loadingCategories = true;
  urlName = '';
  selectedCategory: any = null;
  filterSelected: string[] = []
  ordersTag: FormGroup;
  filterUrl = this.benefitsService.url_filters;
  intervalo: any;
  filterCtrl = new FormControl();
  toggle: boolean = true;
  keywords: string = '';
  keywords_prefix: string = 'palabra-clave-';
  lat_data = this.benefitsService.data_latitud;
  lon_data = this.benefitsService.data_longitud;
  mapa_data = this.benefitsService.data_mapa;
  ord_data = this.benefitsService.data_ordenamiento;
  showFilterMobile : boolean = false;
  orders: any = [{id: 2, 'Mayor Descuento': false, label: 'Mayor Descuento', url: 'mayor-descuento' }, {id: 3, 'Más Recientes': false, label: 'Más Recientes', url: 'mas-recientes'}, {id: 4, 'A-Z': false, label: 'A-Z', url: 'a-z'}, {id: 5, 'Z-A': false, label: 'Z-A', url: 'z-a'}];

  constructor(
    fb: FormBuilder,
    private benefitsService: BenefitsService,
    private categoryService: CategoryService,
    private activatedRoute: ActivatedRoute,
    private sliderService: SliderService,
    private router: Router
  ) {
    this.urlName = this.activatedRoute.snapshot.params['category'];

    this.setCategory( this.categoryService.selectedCategory );
    this.categoryService.selectedCategoryChange.subscribe((cat) => this.setCategory( cat ));
    this.ordersTag = fb.group(this.orders.reduce((a: any, v: any) => ({ ...a, [v.label]: v[v.label]}), {}));
   }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
        return false;
    };
    this.readUrlParams();
  }
  setCategory( category: any )
  {
    this.selectedCategory = category;
    this.filterByCategory(category);

  } 
  getPictureItem(item: any) {
    if(window.innerWidth < 1000)
        return item.benefit?item.benefit.photo_mobile:item.photo_mobile;
    else
        return item.benefit?item.benefit.photo:item.photo;
  }

  getSlider(category:any) {
    let tthis = this;
    this.sliderService
      .getCurrent()
      .toPromise()
      .then((sliders: any) => {
        let slidersCategoria = sliders.filter((e:any) => e.slider_Type.name == 'Beneficios' && category.includes(e.category.id)).sort((a: any, b: any) => a.order - b.order);
        if(slidersCategoria.length > 0) {
          tthis.sliders = slidersCategoria;
        }
      });
  }

  showMobileFilter() {
    this.showFilterMobile = !this.showFilterMobile;
  }

  navigate(item:any) {
    if(item.url && !item.benefit)
      window.open(item.url, "_blank");
  }

  hideMobileFilter() {
    this.showFilterMobile = false;
  }

  readUrlParams(){
    var category = this.activatedRoute.snapshot.params['category'];
    var url = this.filterUrl

    if(category != undefined){
      //handle keyword filter
      if(category.includes(this.keywords_prefix)){
        let keyword_handler = category.split(this.keywords_prefix);

        if(keyword_handler.length > 1){
          this.keywords = keyword_handler[1];
        }
      }

      let flag = false

      this.orders.forEach((item:any, i:any )=>{
        if(category.includes(item.url)){
          this.orders[1][this.orders[1].label] = false

          this.ord_data = item.id;
          this.orders[i][item.label] = true
          if(!url.includes(this.orders[i].url)){
            url.push(this.orders[i].url)
          }

          flag = true
        }
      });

      if(flag == false){
        this.ord_data = 3;
        this.orders[1][this.orders[1].label] = true
        if(!url.includes(this.orders[1].url)){
          url.push(this.orders[1].url)
        }
      }

    }else{
      this.ord_data = 3;
      this.orders[1][this.orders[1].label] = true
    }

    this.getBenefits();
  }

  addCategories(event:any): void {
    const selected = this.filterSelected;

    const value = this.categoriesTag.value;
    const valueArray = Object.entries(value);
    const filtered = valueArray.filter(([key, value]) => value == true);
    const falseFiltered = valueArray.filter(([key, value]) => value == false);

    // Add our filter
    filtered.forEach((category, i) => {
      if( !selected.includes(category[0]) ){
        var urlFilter = this.getUrlName(category[0])

        this.filterUrl.push(urlFilter)
        selected.push(category[0])

        this.setearIntervalo(this.filterUrl)
      }
    })

    // Remove our filter
    falseFiltered.forEach((category, i)=>{
      if( selected.includes(category[0]) ){
        var index = selected.indexOf(category[0]);
        if (index !== -1) {
          this.filterUrl.splice(index, 1)
          selected.splice(index, 1);
        }

        this.setearIntervalo(this.filterUrl)
      }
    })

    this.filterCtrl.setValue(null);
  }

  changeKeywordFilter(event: any){
    this.keywords = event.target.value;
  }

  applyKeywordFilter(){
    var newFilter = this.filterUrl.filter(e => e.indexOf(this.keywords_prefix) != -1);

    this.filterUrl = newFilter

    if(this.keywords.trim().length > 0){
      this.filterUrl.push(this.keywords_prefix + this.keywords)
    }

    this.benefitsService.filterCategories(this.filterUrl);

    return false;
  }

  setearIntervalo(filterurl:string[]){
    if(this.intervalo != undefined){
      clearInterval(this.intervalo)
    }

    this.intervalo = setInterval(()=>{
      this.benefitsService.filterCategories(filterurl);
    }, 2000);

  }

  getUrlName(filter: string){
    var filter_name = filter.replace(/ /g, '-');
    filter_name = filter_name.replace(/\//g, '-');
    filter_name = filter_name.replace("%", 'porcentaje');
    filter_name = filter_name.toLowerCase();
    filter_name = filter_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return filter_name;
  }

  filterByCategory(cat: any): void {
    if (cat !== null) {
      this.displayedBenefits = this.benefits.filter((e: any) => {
        var ok = false;

        if (e.category.id == cat.id && e.redeemCodes === true) {
          ok = true;
        }

        return (e.category.id === cat.id && e.redeemCodes === true || ok);
      });
    } else {
      this.displayedBenefits = this.benefits.filter((e: any) => e.redeemCodes === true);
    }

  }

  async getBenefits() {
    this.keywords = this.keywords.trim().toLowerCase();
    const desiredCategories = [
      'Compras',
      'Cuidado Personal',
      'Gaming',
      'Indumentaria',
      'Infantil',
      'Tecnología',
    ];
    try {
      const res = await this.benefitsService.filterBenefits(this.lat_data, this.lon_data, this.mapa_data, this.ord_data, this.keywords).toPromise();
      this.benefits = Array.isArray(res)
        ? res.filter((item: Benefit) => 
            item.redeemCodes === true &&
            desiredCategories.includes(item.category?.name ?? '')
          )
        : [];

      this.displayedBenefits = this.benefits;

      setTimeout(() => {
        this.loadingBenefits = false;
      }, 500);
    } catch (error) {
      console.error('Error al obtener beneficios:', error);
      this.loadingBenefits = false;
    }
  }
}

